<p-table [value]="sezioni$ | async" [paginator]="true" [rows]="10" [alwaysShowPaginator]="false">
  <ng-template pTemplate="header">
    <tr>
      <th class="width100">Sezione</th>
      <th>Descrizione</th>
      <th class="width200">Classifica in sezione</th>
      <th class="width200">Qualifica in sezione</th>
      <th class="width100">Esercitazione</th>
      <th class="width82"> <button class="addButton" pButton type="button" icon="fas fa-plus" title="Aggiungi"
          (click)="openModal('new')"></button></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-sez let-i="rowIndex">
    <tr>
      <td class="width100 center">{{ sez.nomeSezione }}</td>
      <td class="center">{{ sez.descrizione }}</td>
      <td class="width200 center">{{ getClassifica(sez)?.nomeClassifica }}</td>
      <td class="width200 center">{{ getQualifica(sez)?.nomeQualifica }}</td>
      <td class="width100 center">{{ sez.esercitazione ? "SI" : "NO" }}</td>
      <td class="width82 center">
        <button pButton type="button" style="margin-right: 5px;" icon="fas fa-pen" class="p-button-warning"
          title="Modifica" (click)="openModal('edit', sez)"></button>
        <button pButton type="button" icon="fas fa-times" class="p-button-danger" title="Elimina"
          (click)="removeItem(sez)"></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="4">
        Nessuna sezione trovata
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog [(visible)]="isDialogOpen" [modal]="true" [closable]="false" [closeOnEscape]="false" [resizable]="false">
  <p-header>
    <span *ngIf="editMode==='new'">Aggiungi sezione</span>
    <span *ngIf="editMode==='edit'">Modifica sezione</span>
  </p-header>
  <div class="grid">
    <form [formGroup]="form">
      <div class="col-12">
        <div class="col-3" style="margin-top:6px;">Codice*</div>
        <div class="col-12">
          <input id="nomeSezione" type="text" pInputText formControlName="nomeSezione" title="Codice">
        </div>
      </div>
      <div class="col-12">
        <div class="col-3" style="margin-top:6px;">Descrizione</div>
        <div class="col-12">
          <input id="descrizione" type="text" pInputText formControlName="descrizione" title="Descrizione">
        </div>
      </div>
      <div class="col-12">
        <div class="col-12">Classifiche*</div>
        <p-listbox class="col-9" [options]="classifiche" optionLabel="nomeClassifica" dataKey="classificaId"
          formControlName="classifica"></p-listbox>
      </div>
      <div class="col-12">
        <div class="col-12">Qualifiche*</div>
        <p-listbox class="col-9" [options]="qualifiche" optionLabel="nomeQualifica" dataKey="qualificaId"
          formControlName="qualifica"></p-listbox>
      </div>
      <div class="col-12">
        <div class="col-3" style="margin-top:6px;">Esercitazione</div>
        <div class="col-12">
          <p-radioButton name="esercitazione" [value]="true" formControlName="esercitazione"
            label="SI"></p-radioButton>&nbsp;&nbsp;&nbsp;
          <p-radioButton name="esercitazione" [value]="false" formControlName="esercitazione"
            label="NO"></p-radioButton>
        </div>
      </div>
    </form>
  </div>
  <p-footer>
    <button pButton type="button" label="Annulla" class="p-button-secondary" title="Annulla"
      (click)="resetForm()"></button>
    <button pButton type="button" [label]="editMode === 'new' ? 'Aggiungi' : 'Modifica'"
      [title]="editMode === 'new' ? 'Aggiungi' : 'Modifica'" (click)="saveItem()" [disabled]="form.invalid"></button>
  </p-footer>
</p-dialog>

<p-toast key="toast" position="top-center"></p-toast>